import { Link } from 'react-router-dom';
import heroImage from '../../assets/images/heroimage.svg';

export default function Hero() {
  return (
    <section className="pt-24 pb-0 bg-white overflow-hidden">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="flex flex-col items-center gap-8 pt-16 text-center">
          {/* Heading */}
          <h1 className="text-[38px] md:text-6xl lg:text-[72px] font-bold text-[#080808] leading-tight max-w-[900px]">
            AI document parsing<br />and extraction
          </h1>

          {/* Subtitle */}
          <p className="text-lg text-[#08080899] leading-relaxed max-w-[720px]">
            Convert complex documents into clean, structured data for LLM-based and<span className="hidden md:inline"><br /></span>{' '}other use cases - RAG pipelines, AI agents, JSON extraction, and more.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="https://docstrange.nanonets.com/app"
              className="inline-flex items-center justify-center px-6 py-3 w-full sm:w-[182px] bg-[#546FFF] text-white rounded-lg font-semibold text-base hover:bg-[#3A4DB2] transition-colors duration-200"
            >
              Start Free Trial
            </Link>
            <Link
              to="/demo"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 w-full sm:w-[182px] bg-white text-[#080808] border border-[#E0E0E0] rounded-lg font-medium text-base hover:border-[#546FFF] transition-colors duration-200"
            >
              Request a demo
            </Link>
          </div>

        </div>
      </div>

      {/* Hero image — full bleed, wider than content container */}
      <div className="w-full max-w-[1600px] mx-auto px-0 mt-8">
        <img
          src={heroImage}
          alt="AI document parsing and extraction platform — Nanonets Docstrange dashboard"
          className="w-full"
          fetchpriority="high"
          decoding="sync"
          style={{ transform: 'translateX(-6%)' }}
        />
      </div>
    </section>
  );
}
